import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M 50 10 A 40 40 0 0 1 90 50",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "5",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import "./Loader.scss";

interface Props
{
	size? : number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    size: { default: 48 }
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", {
    class: "loader",
    style: _normalizeStyle({ width: _unref(props).size, height: _unref(props).size })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 100 100",
      width: _unref(props).size,
      height: _unref(props).size,
      "aria-hidden": "true"
    }, _hoisted_3, 8, _hoisted_1))
  ], 4))
}
}

})